// THIS FILE IS AUTOMATICALLY GENERATED
// The uncompressed length of the MBF agent in bytes.
export const AGENT_LENGTH: number = 13230240
// The SHA1 hash of the MBF agent, as a string base64 encoded.
export const AGENT_SHA1: string = "9EA67E6B78ACA181C6CFF0B359ABE44862CB1F4F"
